/**
 * Client API de la clé d'agent et du journal de l'agent (brique 2 du projet MCP).
 *
 * Toutes ces routes sont celles de l'HUMAIN, par sa session : un jeton d'agent
 * y est refusé. La clé elle-même n'apparaît qu'une fois, dans la réponse de
 * `regenererCle()`, et ne doit être gardée que dans l'état d'un composant —
 * jamais dans un store persisté, jamais dans localStorage.
 *
 *   GET    /api/agent/cle            → état de la clé (créée au premier passage)
 *   POST   /api/agent/cle/regenerer  → nouvelle clé, en clair UNE fois
 *   DELETE /api/agent/cle            → couper l'agent
 *   GET    /api/agent/journal        → lignes du journal et totaux
 */
import { API_URL, messageDErreur } from './client';
import { useAuthStore } from '../store/useAuthStore';


async function authFetch(path, options = {}) {
  const { authFetch: af } = useAuthStore.getState();
  const res = await af(`${API_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });
  if (!res.ok) {
    let detail = `Erreur ${res.status}`;
    try { const j = await res.json(); if (j.detail) detail = messageDErreur(j.detail, detail); }
    catch (_) { /* not json */ }
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  return res.json();
}


/** État de la clé : { etat: 'active'|'coupee', prefixe, droits, cree_le, expire_le, dernier_usage_le, revoquee_le }. */
export async function lireCleAgent() {
  return authFetch('/api/agent/cle');
}


/** Nouvelle clé : même forme que lireCleAgent, plus `cle` (le clair, une seule fois) et `avertissement`. */
export async function regenererCleAgent() {
  return authFetch('/api/agent/cle/regenerer', { method: 'POST' });
}


/** Couper l'agent : la clé est révoquée, l'agent est refusé dès son appel suivant. */
export async function couperAgent() {
  return authFetch('/api/agent/cle', { method: 'DELETE' });
}


/** Journal de l'agent : { lignes: [...], totaux: {...} }, sur une conversation ou sur tout le journal. */
export async function lireJournalAgent({ conversation, limite = 10 } = {}) {
  const params = new URLSearchParams({ limite: String(limite) });
  if (conversation) params.set('conversation', conversation);
  return authFetch(`/api/agent/journal?${params}`);
}
